import { useQuery } from '@tanstack/react-query';

import type AgentApiCompaniesMasterData from '@/types/serializers/AgentApiCompaniesMasterData';

type Request = {
  query: string;
};

export default function useFetchCompaniesMasterData(searchQuery: Request) {
  const query = (searchQuery.query || '').trim();

  return useQuery({
    queryKey: ['companiesMasterData', query],
    queryFn: async () => {
      const response = await fetch(
        `/agent/api/companies/master_data.json?query=${encodeURIComponent(query)}`
      );
      const data: AgentApiCompaniesMasterData[] = await response.json();
      return data;
    },
    enabled: Boolean(query.length > 0),
  });
}
